import { API_URL } from "utils/constants";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms)); // untuk test loading state

const MAX_RETRIES = 3; // Jumlah maksimal retry
const BACKOFF_BASE_TIME = 45000; // Waktu backoff dasar dalam ms

const fetchWrapper = async (url, method, data, retries = MAX_RETRIES) => {
  const options = {
    method,
    headers: {
      "Content-Type": "application/json",
    },
  };

  const token = localStorage.getItem("token");

  if (token) {
    options.headers.Authorization = `Bearer ${token}`;
  }

  if (data) {
    options.body = JSON.stringify(data);
  }

  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      const response = await fetch(`${API_URL}${url}`, options);

      if (!response.ok) {
        // 🔹 **Jika 401 (Unauthorized), logout dan redirect**
        if (response.status === 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          window.location.href = "/v1/login"; // ✅ Gunakan `href` agar reload terjadi
          break; // ✅ Hentikan perulangan
        }
        if (response.status === 429 && attempt < retries) {
          // Jika Too Many Requests, tunggu waktu backoff
          const retryAfter = response.headers.get("Retry-After");
          const delayTime = retryAfter
            ? parseInt(retryAfter, 10) * 1000
            : BACKOFF_BASE_TIME * Math.pow(2, attempt); // Exponential backoff
          await delay(delayTime);
          continue; // Coba lagi
        }

        const errorData =
          response.status === 422 ? await response.json() : null;
        if (response.status === 422) {
          let errorMessage = "Validation Error";
          if (errorData.errors) {
             errorMessage = Object.values(errorData.errors).flat().join("\n");
          } else if (errorData.message) {
             errorMessage = errorData.message;
          }
          const error = new Error(errorMessage);
          error.code = errorData.code;
          error.errors = errorData.errors;
          error.status = 422;
          // Respons bulk atomic yang di-rollback membawa summary + results per item di `data`.
          error.data = errorData.data;
          throw error;
        } else {
          const errorResponse = await response.json().catch(() => ({}));
          const error = new Error(errorResponse.message || "API Error");
          error.code = errorResponse.code;
          error.status = response.status;
          throw error;
        }
      }

      return await response.json(); // Berhasil, kembalikan respons JSON
    } catch (error) {
      if (attempt === retries) {
        // Jika telah mencapai batas retry, lemparkan error
        throw error;
      }
    }
  }
};

export const postRequest = (url, data) => fetchWrapper(url, "POST", data);
// Tanpa retry otomatis: untuk endpoint yang tidak boleh terkirim dua kali (mis. bulk create/move/delete).
export const requestOnce = (url, method, data) => fetchWrapper(url, method, data, 0);
export const patchRequest = (url, data) => fetchWrapper(url, "PUT", data);
export const deleteRequest = (url) => fetchWrapper(url, "DELETE");
export const getRequest = (url) => fetchWrapper(url, "GET");
